import {map} from 'rxjs/operators';
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import * as moment from 'moment';
import {PermissionToolkitService} from "../permission-toolkit.service";
import {StorageService} from "../storage.service";

@Injectable()
export class AuthenticationService {
    currentUser: any;
    public token: string;
    httpBase;

    constructor(
        private http: HttpClient,
        private cookieService: CookieService,
        private permissionToolkitService: PermissionToolkitService,
        private storageService: StorageService,
        @Inject('httpBaseSettings') public httpBaseSettings: any
    ) {
        // set token if saved in local storage
        const userStr = this.cookieService.get('currentUser');
        if (userStr) {
            this.currentUser = JSON.parse(userStr);
        }
        this.httpBase = this.httpBaseSettings?.httpBase || '';
    }

    getToken() {
        return this.currentUser ? this.currentUser.token : undefined;
    }

    refreshToken() {
        const sysUser = this.storageService.getItem('sysUser');
        if (sysUser) {
            const requestParam = {
                refreshToken: this.cookieService.get('refreshToken'),
                token: this.cookieService.get('token'),
                sysUserId: sysUser.id
            }
            return this.http.post( this.httpBase + '/base/auth/refreshToken', requestParam).pipe(
                map(response => {
                        console.log(response);
                    }
                ));
        }
    }

    analyzeToken(token) {
        const headers = new HttpHeaders();
        headers['authorization'] = token;
        return this.http.get(this.httpBase + '/fixedToken/auth', {headers: headers}).pipe(map(res => res['data'] || null));
    }

    login(username: string, password: string) {
        return this.http.post(this.httpBase + '/base/auth', { userCode: username, password: password }).pipe(
            map( response => {
            // login successful if there's a jwt token in the response
                if (response['code'] === 0) {
                    const token = response && response['data'] && response['data']['token'];
                    const privilegeList = response && response['data'] && response['data']['privilegeList'];
                    const sysUser = response && response['data'] && response['data']['sysUser'];
                    const refreshToken = response && response['data'] && response['data']['refreshToken'];
                    this.cookieService.set('refreshToken', refreshToken);
                    if (privilegeList) {
                        this.storageService.setLocalItem('privilegeList', privilegeList);
                    } else {
                        this.storageService.setLocalItem('privilegeList', []);
                    }

                    this.cookieService.set('authTime', moment().format());

                    if (sysUser) {
                        this.cookieService.set('sysUser', JSON.stringify(sysUser));
                    } else {
                        this.cookieService.set('sysUser', '{}');
                    }

                    if (token) {
                        // set token property
                        this.token = token;
                        this.cookieService.set('tokenCheck', '1', moment().add(30, 'm').toDate());
                        this.cookieService.set('token', token);

                        this.permissionToolkitService.setUserPrivilegeList(privilegeList);
                        return sysUser;
                    } else {
                        // return false to indicate failed login
                        return null;
                    }
                } else {
                    // return false to indicate failed login
                    return null;
                }
            }
        ));
    }

    logOut() {
        return this.http.delete(this.httpBase + '/base/auth');
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        this.token = undefined;
        this.currentUser = undefined;
        this.storageService.clearUserInfo();
    }
}
